export default function capitalize(str) {
  return str.replace(/\b[a-zA-Z]/g, match => match.toUpperCase());
}
